import axios from "axios";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logout, resetAuthState } from "../redux/actions/auth";
import { resetUserState } from "../redux/actions/userDetails";
import { Redirect } from "react-router";
import routes from "../config/routes";
import ToastifyIconComponent from "../components/Common/ToastifyIconComponent";


let showSnackBar = true;
const initTransportInterceptor = (store) => {
  // TODO: Token should be sent using this snippet
  /*
  axios
    .interceptors
    .request
    .use(
      (config) => {
        const token = localStorage.getItem('Token');

        config.headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        };

        return config;
      },
    );
  */

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (err) => {
      const error = {
        status: err?.response?.status,
        title: err?.response?.data?.message,
      };

      if (error.status === 401 && error.title === "Unauthorized") {
        console.log('sign in failed')
        // localStorage.clear();
        const message = `${error.status} / ${error.title}`;
        if(showSnackBar && error.status == 401) {
          showSnackBar = false;
          toast.error(<div className="content">Your session has expired. Please login again</div>, {
            icon: () => (<ToastifyIconComponent />),
            className: "midl-toast",
          });
        }
        // else if (showSnackBar) {
        //   toast.error(message);
        // } 
        store.dispatch(logout());
        setTimeout(() => {
          showSnackBar = true;
        }, 4000)
      } else if (error.status === 0) {
        console.log("Err", error);
      } else {
        const message = `${error.status} / ${error.title}`;
        toast.error(<div className="content">{message}</div>, {
          icon: () => (<ToastifyIconComponent />),
          className: "midl-toast",
        });
      }

      return Promise.reject(err);
    }
  );
};

const initInterceptors = (store) => {
  initTransportInterceptor(store);
};

export default initInterceptors;
